<script>
  export let title = "";
  export let hint = "";
</script>

<!-- Content for the SectionWrapper emptyState slot, same look as AnonymizationEmptyState. -->
<div class="empty_state_body">
  <div class="empty_state_title">{title}</div>
  {#if hint}<div class="empty_state_hint">{hint}</div>{/if}
  {#if $$slots.actions}
    <!-- Positioned below the text so the info icon centers on title and hint only. -->
    <div class="empty_state_actions"><slot name="actions" /></div>
  {/if}
</div>

<style>
  .empty_state_body {
    position: relative;
  }

  .empty_state_title,
  .empty_state_hint {
    font-size: 1rem;
  }

  .empty_state_title {
    color: var(--pax-black);
  }

  .empty_state_hint {
    max-width: 32rem;
    margin-top: 0.5rem;
    color: var(--pax-grey);
  }

  .empty_state_actions {
    position: absolute;
    top: 100%;
    left: 0;
    display: flex;
    gap: var(--control-gap, 0.5rem);
    margin-top: 1rem;
  }
</style>
